import profileTpl from './profile.tpl.html';
'use strict';
(function () {
  angular.module('student.profile').component('studentProfile', {
    template: profileTpl,
    bindings: {
      hideTitleAndTabs: '<'
    }
  });
})();